<template>
  <DashboardTemplate>
    <div class="query-box">
      <p class="color-primary mg-y-less">
        <span class="text-font-14"
          >{{ totalCourse }} ผลลัพธ์ สำหรับคำค้นหา
        </span>
        <span class="text-font-16 text-weight-600">“{{ searchText }}”</span>
      </p>
    </div>
    <div v-if="courseList.length > 0">
      <div v-for="(item, index) in courseList" :key="index" class="position-relative">
        <SearchCard
          :id="item._id"
          :name="item.name"
          :image="
            typeof item.illustration != 'undefined' ? item.illustration.file : ''
          "
          :disabled="item.statusCourse == 0"
          :class="{'cursor-not-allowed':item.statusCourse == 0}"
        />
        <el-button v-if="item.statusCourse == 0"  type="primary" class="coming-button cursor-not-allowed" round>หลักสูตรจะเปิดเร็ว ๆ นี้</el-button>
      </div>
    </div>
    <p v-else class="color-gray pd-t-1">*** ไม่พบข้อมูล ***</p>
    <div v-if="totalCourse > 10" class="pd-y-3">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next"
        :total="totalCourse"
        :page-size="10"
        :current-page="page"
      >
      </el-pagination>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import SearchCard from "@/components/search/SearchCard";
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  components: {
    DashboardTemplate,
    SearchCard,
  },
  data() {
    return {
      searchText: "",
      page: 1,
      pageSize: 10,
      totalCourse: 0,
      courseList: [],
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourse();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.query != "undefined") {
          this.searchText = this.routeParams.query;
        }
      }
    },
    changePage(page) {
      this.page = page;
      this.fetchCourse();
    },
    fetchCourse() {
      HTTP.get(
        `list/course/${(this.page - 1) * this.pageSize}/${this.pageSize}/${
          this.searchText != "" ? this.searchText : "all"
        }`
      )
        .then((res) => {
  
          if (res.data.success) {
            this.courseList = res.data.obj;
            this.totalCourse = res.data.count;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchCourse error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>

<style scoped>
.query-box {
  background: rgba(51, 160, 244, 0.2);
  border-radius: 8px;

  padding: 15px 30px 15px 30px;
  text-align: left;
}
</style>
